// Create a validation factory/helper
export const createValidations = (options = {}) => {

  // Default validators that can be enabled/disabled
  const validators = {
    // Empty check validator
    isEmpty: options.validateEmpty ?
      (term) => term.trim() === "" :
      () => false, // Disabled validator always returns false (no validation error)

    // Length check validator
    isLengthExceeded: options.validateLength ?
      (term, maxLength) => term.trim().toLowerCase().length > maxLength :
      () => false,

    // Duplicate check validator
    isDuplicate: options.validateDuplicates ?
      (term, ignoreListItems, originalIndex) => {
        let isDuplicate = false;
        ignoreListItems.forEach((ignoreListItem, index) => {
          if (index === originalIndex) return; // Skip comparing a term with itself

          if (ignoreListItem.term.trim().toLowerCase() === term.trim().toLowerCase()) {
            isDuplicate = true;
          }
        });
        return isDuplicate;
      } :
      () => false,
  };

  // Error messages for validation failures
  const errorMessages = {
    isEmpty: "Ignore term can't be empty",
    isLengthExceeded: (maxLength) => `Ignore term length cannot be greater than "${maxLength}" characters`,
    isDuplicate: (term) => `The ignore term "${term}" already exists in the list. Please re-enter and try again.`,
  };

  // Return the configured validation object
  return {
    maxLength: options.maxLength || 50,
    validators,
    errorMessages,
    enabledValidators: Object.keys(validators).filter(key => {
      // Map to check if each validator is enabled
      const validatorMap = {
        isEmpty: options.validateEmpty === true,
        isLengthExceeded: options.validateLength === true,
        isDuplicate: options.validateDuplicates === true
      };
      return validatorMap[key];
    })
  };
};